import { render, staticRenderFns } from "./cooperation-my-report-change-cp.vue?vue&type=template&id=56e8514f&scoped=true&"
import script from "./cooperation-my-report-change-cp.vue?vue&type=script&lang=js&"
export * from "./cooperation-my-report-change-cp.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-my-report-change-cp.vue?vue&type=style&index=0&id=56e8514f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e8514f",
  null
  
)

export default component.exports